module.exports = __webpack_public_path__ + "img/tou4.ebaaa621.jpg";